import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué son las Flores Eternas Deco?',
  a: 'Son flores decorativas hechas con limpiapipas, también conocidos como chenille. Son flexibles, coloridas y no se marchitan, por eso son ideales para regalar, decorar o vender.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El kit está pensado para principiantes y te guía paso a paso desde cero.'
}, {
  q: '¿Qué materiales necesito para empezar?',
  a: 'Principalmente limpiapipas y algunos materiales simples de apoyo. Dentro del kit recibís una checklist para saber qué comprar sin gastar de más.'
}, {
  q: '¿El kit es físico o digital?',
  a: 'Es un kit digital. Accedés al material online desde tu celular, tablet o computadora.'
}, {
  q: '¿Tengo acceso de por vida?',
  a: 'Sí. Una vez que comprás, tenés acceso de por vida al contenido. Si el kit se actualiza, también vas a poder acceder a esas mejoras.'
}, {
  q: '¿Puedo vender las flores que aprenda a hacer?',
  a: 'Sí. Podés usar lo aprendido para crear flores, ramos y regalos personalizados para vender por WhatsApp, Instagram, ferias o fechas especiales.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-50">
      <div className="text-center mb-8 sm:mb-10 px-2" data-id="element-51">
        <h2 className="text-3xl sm:text-4xl text-deco-text mb-4 font-bold leading-tight" data-id="element-52">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="space-y-3 sm:space-y-4" data-id="element-53">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[1.5rem] border border-deco-warm overflow-hidden shadow-sm" data-id="element-54">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-deco-bg transition-colors" data-id="element-55">
              <span className="font-serif font-bold text-base sm:text-lg text-deco-text pr-6 leading-tight" data-id="element-56">
                {faq.q}
              </span>
              <ChevronDown className={`text-deco-terra shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-57" />
            </button>

            <AnimatePresence data-id="element-58">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-59">
                  <div className="px-6 pb-6 pt-1 text-deco-text/80 leading-relaxed font-normal text-sm sm:text-base border-t border-deco-warm/50" data-id="element-60">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}